
import { AxiosRequestConfig } from 'axios'
import { AuthorizationsUser, ChangePassword, SignInCredentials } from 'ecp/repositories/LoginRepository'
import { IResponseBase, Repository } from 'ecp/repositories/Repository'
import { ICheckTypistResponse } from 'ecpf/repositories/SigninECPFRepository'
import { IAuth } from 'egi/types'
import api from 'services/api'

export interface IResetPasswordResponse {
  expiresIn: number
  isVinculateWithOnidata: boolean
  email: string
}

class LoginRepositoryEgi extends Repository {
  async reset (data: { identifier: string, withMFA?: boolean }, config?: AxiosRequestConfig) {
    return Repository.handle<IResetPasswordResponse | ICheckTypistResponse>(() =>
      this.api.post(`${this.path}/password/reset`, data, config)
    )
  }

  async login (credentials: SignInCredentials, config?: AxiosRequestConfig) {
    return Repository.handle<IResponseBase>(() =>
      this.api.post(this.path, credentials, config)
    )
  }

  async authorizations (data: SignInCredentials, config?: AxiosRequestConfig) {
    return Repository.handle<{
      users: Array<AuthorizationsUser>
    }>(() =>
      this.api.post(`${this.path}/authorizations`, data, config)
    )
  }

  async changePassword (credentials: ChangePassword, config?: AxiosRequestConfig) {
    return Repository.handle<IAuth>(() =>
      this.api.post(`${this.path}/change/password`, credentials, config)
    )
  }

  async ssoLogin (body: Partial<{ ssoToken: string }>) {
    return Repository.handle<{signin: IAuth}>(() =>
      this.api.post(`${this.path}/sso`, body)
    )
  }
}

export default new LoginRepositoryEgi({ api, path: '/login' })
